import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { OrgProfile, OrgProfileParams } from './model';
import { OrgProfileView } from './view';
import { AppWrapper } from '../appwrapper/model';
import { AppWrapperView } from '../appwrapper/view';

export const OrgProfileRoute = (model : (params : OrgProfileParams) => OrgProfile, appWrapper : AppWrapper, request : Location) : IRoute => ({
    view:
        <AppWrapperView model={appWrapper}>
            <OrgProfileView model={model(convertParams(request))} />
        </AppWrapperView>
});

function convertParams(request : Location) : OrgProfileParams {
    let id = parseInt(request.params['id'] || '', 10);
    if (isNaN(id)) throw new Error('OrgProfile: id param is required and must be numeric.');
    return new OrgProfileParams(id);
}


// WEBPACK FOOTER //
// ./apps/portcall/orgprofile/route.tsx